import React from 'react'
import { formatDate } from '@btime/helpers'

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import Separator from '../../../../components/pdf/Separator'
import Image from '../../../../components/pdf/Image'
import View from '../../../../components/pdf/View'
import Text from '../../../../components/pdf/Text'
import Grid from '../../../../components/pdf/Grid'
import {
  filterRepliesByParentReference,
  findReplyByQuestionId,
  getRepliesFromBlockQuestion,
  getReplyValue,
  toCurrency
} from '../_helpers/pdfHelpers'

const AirfareTemplate = () => {
  const parentServiceOrder = useServiceOrder()
  const replies = parentServiceOrder.replies
  const placeName = parentServiceOrder.place?.name
  const placeResume = parentServiceOrder.place?.resume

  const place = [placeName, placeResume].join(', ')

  const clientName = getReplyValue(findReplyByQuestionId(replies, 464))?.name
  const startDate = getReplyValue(findReplyByQuestionId(replies, 466))
  const endDate = getReplyValue(findReplyByQuestionId(replies, 467))
  const formattedStartDate = formatDate('DD/MM/YYYY', startDate)
  const formattedEndDate = formatDate('DD/MM/YYYY', endDate)
  const baggage = getReplyValue(findReplyByQuestionId(replies, 474))
  const total = getReplyValue(findReplyByQuestionId(replies, 475))
  const paymentMethod = getReplyValue(findReplyByQuestionId(replies, 512))

  const airFareBlock = () => {
    const blockReply = findReplyByQuestionId(replies, 470)
    const airFareReplies = filterRepliesByParentReference(replies, blockReply.question.reference)

    const airFareResult = {}
    airFareReplies.forEach(airFareReply => {
      const blockIndex = airFareReply.blockIndex
      let airFareData = airFareResult[blockIndex]
      if (!airFareData) {
        const blockReplies = getRepliesFromBlockQuestion(airFareReplies, blockIndex)
        airFareData = {
          from: getReplyValue(findReplyByQuestionId(blockReplies, 468)),
          to: getReplyValue(findReplyByQuestionId(blockReplies, 469)),
          departureDate: formatDate('DD/MM/YYYY', getReplyValue(findReplyByQuestionId(blockReplies, 471))),
          arrivalDate: formatDate('DD/MM/YYYY', getReplyValue(findReplyByQuestionId(blockReplies, 472))),
          airCompany: getReplyValue(findReplyByQuestionId(blockReplies, 473))
        }
        airFareResult[blockIndex] = airFareData
      }
    })
    return Object.values(airFareResult)
  }

  const airFareBlockReplies = airFareBlock()

  return (
    <View pageBreakAfter>
      <Grid justify="left" align="left">
        <Image src="/pdfs/universal/passagem-aerea-header.jpg" ignoreFixedSize />
      </Grid>

      <Separator weight={10} />

      <Table width="100%" color="#0a374a">
        <TableRow color="#0a374a">
          <TableCol width="30%" bgColor="#0a374a" style={{ padding: '10px' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Para:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>{clientName}</Text>
          </TableCol>
        </TableRow>
        <TableRow color="#0a374a">
          <TableCol width="30%" bgColor="#0a374a" style={{ padding: '10px', borderTop: '1px solid #fff' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Destino:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>{place}</Text>
          </TableCol>
        </TableRow>
        <TableRow color="#0a374a">
          <TableCol width="30%" bgColor="#0a374a" style={{ padding: '10px', borderTop: '1px solid #fff' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Data da Viagem:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>
              {formattedStartDate} - {formattedEndDate}
            </Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={5} />

      <Table width="100%" color="#0a374a">
        <TableRow color="#0a374a">
          <TableCol bgColor="#0a374a" style={{ padding: '10px' }} color="#0a374a">
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              De
            </Text>
          </TableCol>
          <TableCol bgColor="#0a374a" style={{ padding: '10px' }} color="#fff">
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Para
            </Text>
          </TableCol>
          <TableCol bgColor="#0a374a" style={{ padding: '10px' }} color="#fff">
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Saída
            </Text>
          </TableCol>
          <TableCol bgColor="#0a374a" style={{ padding: '10px' }} color="#fff">
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Chegada
            </Text>
          </TableCol>
          <TableCol bgColor="#0a374a" style={{ padding: '10px' }} color="#fff">
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Cia Aérea
            </Text>
          </TableCol>
        </TableRow>
        {airFareBlockReplies.map(reply => {
          return (
            <>
              <TableRow color="#0a374a">
                <TableCol style={{ padding: '10px' }} color="#0a374a">
                  <Text>{reply.from}</Text>
                </TableCol>
                <TableCol style={{ padding: '10px' }} color="#0a374a">
                  <Text>{reply.to}</Text>
                </TableCol>
                <TableCol style={{ padding: '10px' }} color="#0a374a">
                  <Text>{reply.departureDate}</Text>
                </TableCol>
                <TableCol style={{ padding: '10px' }} color="#0a374a">
                  <Text>{reply.arrivalDate}</Text>
                </TableCol>
                <TableCol style={{ padding: '10px' }} color="#0a374a">
                  <Text>{reply.airCompany}</Text>
                </TableCol>
              </TableRow>
            </>
          )
        })}
      </Table>

      <Separator weight={5} />

      <Table width="100%" color="#0a374a">
        <TableRow color="#0a374a">
          <TableCol width="45%" bgColor="#0a374a" style={{ padding: '10px' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Bagagem incluida?
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>{baggage ? 'Sim' : 'Não'}</Text>
          </TableCol>
        </TableRow>
        <TableRow color="#0a374a">
          <TableCol bgColor="#0a374a" style={{ padding: '10px', borderTop: '1px solid #fff' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Valor total com as taxas de embarque:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>{toCurrency(total)}</Text>
          </TableCol>
        </TableRow>
        <TableRow color="#0a374a">
          <TableCol bgColor="#0a374a" style={{ padding: '10px', borderTop: '1px solid #fff' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Forma de pagamento:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>{paymentMethod}</Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={10} />

      <Grid justify="left" align="left">
        <Image src="/pdfs/universal/information.jpg" ignoreFixedSize />
      </Grid>
    </View>
  )
}

export default AirfareTemplate
